import { Banner, Text } from "@jsq/ds/core";
import { BannerButton } from "~/pages/FundAccounting/Entities/components/styles_vanilla.css";
import { generateGpMainUrl } from "~/utils/url";

type Props = {
  arenaName: string;
  entityName: string;
  arenaSubdomain: string;
  entityId: number;
  hasMixedFunds: boolean;
};

const HasMixedFundsBanner = (props: Props) => {
  const getBannerDescription = () => {
    return `The selected sync date range includes outstanding transfers for ${props.entityName} with a mix of historical capital calls and standalone contributions. Please review transactions in ${props.arenaName}'s workspace.`;
  };

  const bannerDescription = <Text style={{ maxWidth: "700px" }}>{getBannerDescription()}</Text>;
  const gpMainUrl = generateGpMainUrl(props.arenaSubdomain);
  return (
    <Banner
      variant="danger"
      title="Unable to sync transfers"
      description={bannerDescription}
      buttonProps={
        props.hasMixedFunds
          ? {
              children: "Go to entity",
              variant: "neutral",
              className: BannerButton,
              onClick: () => {
                const gpUrl = `${gpMainUrl}/account/${props.entityId}`;
                window.open(gpUrl, "_blank");
              },
              icon: "external-link",
              iconPosition: "right",
            }
          : undefined
      }
    />
  );
};

export default HasMixedFundsBanner;
